import { GridColDef } from "@mui/x-data-grid";

export interface PackageInvoicesRow {
  rowId: string;
  numeroFactura: string;
  nit: string;
  razonSocial: string;
  totalFactura: number;
  estadoFactura: string;
  valorAvalado: number;
  valorGlosaAceptada: number;
  valorEnNoAcuerdo: number;
  auditorAutoriza: string;
}

export const columnsPackageInvoices: GridColDef[] = [
  {
    field: "numeroFactura",
    headerName: "Número de factura",
    width: 150,
    flex: 1,
  },
  {
    field: "nit",
    headerName: "NIT",
    width: 130,
    flex: 1,
  },
  {
    field: "razonSocial",
    headerName: "Razón social",
    width: 200,
    flex: 1,
  },
  {
    field: "totalFactura",
    headerName: "Total factura",
    width: 140,
    flex: 1,
  },
  {
    field: "estadoFactura",
    headerName: "Estado de la factura",
    width: 160,
    flex: 1,
  },
  {
    field: "valorAvalado",
    headerName: "Valor avalado",
    width: 130,
    flex: 1,
  },
  {
    field: "valorGlosaAceptada",
    headerName: "Valor glosa aceptada",
    width: 160,
    flex: 1,
  },
  {
    field: "valorEnNoAcuerdo",
    headerName: "Valor en no acuerdo",
    width: 160,
    flex: 1,
  },
  {
    field: "auditorAutoriza",
    headerName: "Auditor que autoriza",
    width: 180,
    flex: 1,
  },
];
